import Cookies from 'js-cookie'
import Config from '@/settings'
import { refreshNoteice } from '@/noticeMessage';

const TokenKey = Config.TokenKey

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, rememberMe) {
  if (rememberMe) {
    const expireMs = Config.tokenCookieExpires * 60 * 1000;
    const date = new Date();
    date.setTime(date.getTime() + expireMs);
    Cookies.set(TokenKey, token, { expires: date })
  } 
  else {
    Cookies.set(TokenKey, token)
  }
  refreshNoteice()
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}